<template>
    <div class="line-height-1">
        <div class="d-flex align-center">
            {{ reporte.venta | currency(reporte.divisa_code) }}
            <div v-if="reporte.comparison?.venta" class="d-flex text-caption line-height-1 align-center " :class="{
                'accent--text': reporte.comparison.venta[1] >= 0,
                'error--text': reporte.comparison.venta[1] < 0,
            }">
                <div class="ml-1">{{ reporte.comparison.venta[0] | percent }}</div>
                <v-icon v-if="reporte.comparison.venta[1] >= 0" color="accent" x-small>mdi-trending-up</v-icon>
                <v-icon v-else color="error" x-small>mdi-trending-down</v-icon>
            </div>
        </div>
        <div class="">
            <small class="line-height-1 d-flex align-center">
                {{ reporte.count }}
                <div v-if="reporte.comparison?.count" class="d-flex text-caption line-height-1" :class="{
                    'accent--text': reporte.comparison.count[1] >= 0,
                    'error--text': reporte.comparison.count[1] < 0,
                }">
                    <small class="ml-1">{{ reporte.comparison.count[0] | percent }}</small>
                    <v-icon v-if="reporte.comparison.count[1] >= 0" color="accent" x-small>mdi-trending-up</v-icon>
                    <v-icon v-else color="error" x-small>mdi-trending-down</v-icon>
                </div>
            </small>
        </div>
    </div>
</template>
<script>

export default {
    props: {
        reporte: {
            required: true,
        }
    },
}
</script>